import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const StyledEmptyState = styled.div`
    display: grid;
    place-items: center;
    height: 100%;
`;

export const Content = styled.div`
    display: grid;
    gap: 16px;
    text-align: center;
`;

export const Emoji = styled.p`
    ${styledReset.typography};
    font-size: 48px;
`;

export const Message = styled.p`
    ${styledReset.typography};
    font-family: 'Alliance No.1';
    font-size: 14px;
    font-weight: 600;
    color: var(--yat_emoji-list-common-color);
`;
